import type { ReactNode, Ref } from 'react';
import type { SceneStore } from '@os/doc';
import { ObjectView } from '../objects/ObjectView';
import type { MediaResolver } from './lod';
import { useChildIds } from './useObject';
import { EmbedContext, type EmbedControl } from './embeds';

type Props = {
  ref: Ref<HTMLDivElement>;
  store: SceneStore;
  media: MediaResolver;
  register: (id: string, el: HTMLElement | null) => void;
  onObjectRender?: (id: string) => void;
  /** In-place editors, drawn above the objects in world coordinates. */
  children?: ReactNode;
  /** Which embed plays (the controller's); none play without it. */
  embeds?: EmbedControl;
};

/** World layer: its transform is written by the controller; DOM order is paint order (containers hold their children). */
export function World({ ref, store, media, register, onObjectRender, children, embeds }: Props) {
  const ids = useChildIds(store, null);
  return (
    <EmbedContext.Provider value={embeds ?? null}>
      <div ref={ref} data-layer="world" className="absolute left-0 top-0 origin-top-left">
        {ids.map((id) => (
          <ObjectView key={id} store={store} id={id} media={media} register={register} onRender={onObjectRender} />
        ))}
        {children}
      </div>
    </EmbedContext.Provider>
  );
}
